import request from './service/index'

export function competitionList_Api(data){
    return request({
        url:'CMS/competition/competition_list',
        method:'post',
        data:data
    });
}

export function deleteCompetitionList_Api(data){
    return request({
        url:'CMS/competition/competition_list',
        method:'delete',
        data:data
    });
}

export function competitionCount_Api(){
    return request({
        url:'CMS/competition/competition_count',
        method:'get',
    });
}

export function competitionStatus_Api(){
    return request({
        url:'CMS/competition/status',
        method:'get',
    });
}

export function competitionDetail_Api(id){
    return request({
        url:`CMS/competition/competition_detail?competition_id=${id}`,
        method:'get',
    });
}

export function createCompetitionDetail_Api(data){
    return request({
        url:'CMS/competition/competition_detail',
        method:'post',
        data:data
    });
}

export function updateCompetitionDetail_Api(data){
    return request({
        url:'CMS/competition/competition_detail',
        method:'put',
        data:data
    });
}

export function deleteCompetitionDetail_Api(data){
    return request({
        url:'CMS/competition/competition_detail',
        method:'delete',
        data:data
    });
}

export function competitionAward_Api(id){
    return request({
        url:`CMS/competition/competition_award?competition_id=${id}`,
        method:'get',
    });
}

export function getCompetitionAward_Api(id){
    return request({
        url:`CMS/competition/competition_award?award_id=${id}`,
        method:'get',
    });
}

export function createCompetitionAward_Api(data){
    return request({
        url:'CMS/competition/competition_award',
        method:'post',
        data:data
    });
}

export function updateCompetitionAward_Api(data){
    return request({
        url:'CMS/competition/competition_award',
        method:'put',
        data:data
    });
}

export function deleteCompetitionAward_Api(data){
    return request({
        url:'CMS/competition/competition_award',
        method:'delete',
        data:data
    });
}

export function competitionReview_Api(id,config_type){
    return request({
        url:`CMS/competition/competition_review?competition_id=${id}&config_type=${config_type}`,
        method:'get',
    });
}

export function createCompetitionReview_Api(data){
    return request({
        url:'CMS/competition/competition_review',
        method:'post',
        data:data
    });
}

export function updateCompetitionReview_Api(data){
    return request({
        url:'CMS/competition/competition_review',
        method:'put',
        data:data
    });
}

export function deleteCompetitionReview_Api(data){
    return request({
        url:'CMS/competition/competition_review',
        method:'delete',
        data:data
    });
}

export function competitionField_Api(){
    return request({
        url:'CMS/competition/field',
        method:'get',
    });
}

export function getCompetitionField_Api(id){
    return request({
        url:`CMS/competition/competition_field?competition_id=${id}`,
        method:'get',
    });
}

export function createCompetitionField_Api(data){
    return request({
        url:"CMS/competition/competition_field",
        method:'post',
        data:data
    });
}

// export function updateCompetitionField_Api(data){
//     return request({
//         url:"CMS/competition/competition_field",
//         method:'put',
//         data:data
//     });
// }

// export function deleteCompetitionField_Api(data){
//     return request({
//         url:"CMS/competition/competition_field",
//         method:'delete',
//         data:data
//     });
// }

export function getCompetitionInfo_Api(id){
    return request({
        url:`CMS/competition/competition_info?competition_id=${id}`,
        method:'get',
    });
}

export function createCompetitionInfo_Api(data){
    return request({
        url:"CMS/competition/competition_info",
        method:'post',
        data:data
    });
}

export function updateCompetitionInfo_Api(data){
    return request({
        url:"CMS/competition/competition_info",
        method:'put',
        data:data
    });
}

export function deleteCompetitionInfo_Api(data){
    return request({
        url:"CMS/competition/competition_info",
        method:'delete',
        data:data
    });
}

export function CompetitionJudges_Api(id){
    return request({
        url:`CMS/competition/competition_judge?competition_id=${id}`,
        method:'get',

    });
}

export function createCompetitionJudges_Api(data){
    return request({
        url:"CMS/competition/competition_judge",
        method:'post',
        data:data
    });
}

export function updateCompetitionJudges_Api(data){
    return request({
        url:"CMS/competition/competition_judge",
        method:'put',
        data:data
    });
}

export function deleteCompetitionJudges_Api(data){
    return request({
        url:"CMS/competition/competition_judge",
        method:'delete',
        data:data
    });
}

export function clearCompetitionJudges_Api(data){
    return request({
        url:"CMS/competition/allot_clear",
        method:'delete',
        data:data
    });
}

export function competitionClassification_Api(){
    return request({
        url:"CMS/competition/competition_classification",
        method:'get',
    });
}

export function getCompetitionClassification_Api(page){
    return request({
        url:`CMS/competition/competition_classification?page=${page}`,
        method:'get',
    });
}

export function createCompetitionClassification_Api(data){
    return request({
        url:"CMS/competition/competition_classification",
        method:'post',
        data:data
    });
}

export function updateCompetitionClassification_Api(data){
    return request({
        url:"CMS/competition/competition_classification",
        method:'put',
        data:data
    });
}

export function deleteCompetitionClassification_Api(data){
    return request({
        url:"CMS/competition/competition_classification",
        method:'delete',
        data:data
    });
}

export function competitionMaxCommit_Api(id){
    return request({
        url:`CMS/competition/competition_max_commit?competition_id=${id}`,
        method:'get',
    });
}

export function createCompetitionMaxCommit_Api(data){
    return request({
        url:"CMS/competition/competition_max_commit",
        method:'post',
        data:data
    });
}

export function competitionPerson_Api(id){
    return request({
        url:`CMS/competition/competition_person?competition_id=${id}`,
        method:'get',
    });
}

export function createCompetitionPerson_Api(data){
    return request({
        url:"CMS/competition/competition_person",
        method:'post',
        data:data
    });
}

export function updateCompetitionPerson_Api(data){
    return request({
        url:"CMS/competition/competition_person",
        method:'put',
        data:data
    });
}

export function deleteCompetitionPerson_Api(data){
    return request({
        url:"CMS/competition/competition_person",
        method:'delete',
        data:data
    });
}

export function getCompetitionFile_Api(){
    return request({
        url:"CMS/competition/file",
        method:'get',
    });
}

export function competitionFile_Api(id){
    return request({
        url:`CMS/competition/competition_file?competition_id=${id}`,
        method:'get',
    });
}

export function createCompetitionFile_Api(data){
    return request({
        url:"CMS/competition/competition_file",
        method:'post',
        data:data
    });
}

export function updateCompetitionFile_Api(data){
    return request({
        url:"CMS/competition/competition_file",
        method:'put',
        data:data
    });
}

export function deleteCompetitionFile_Api(data){
    return request({
        url:"CMS/competition/competition_file",
        method:'delete',
        data:data
    });
}

export function competitionWorkList_Api(data){
    return request({
        url:"CMS/competition/works_list",
        method:'post',
        data:data
    });
}

export function competitionWorksCount_Api(id){
    return request({
        url:`CMS/competition/works_count?competition_id=${id}`,
        method:'get',
    });
}

export function createCompetitionWorkDetail_Api(data){
    return request({
        url:"CMS/competition/works_detail",
        method:'post',
        data:data
    });
}

export function updateCompetitionWorkDetail_Api(data){
    return request({
        url:"CMS/competition/works_detail",
        method:'put',
        data:data
    });
}

export function competitionWorkDetail_Api(id){
    return request({
        url:`CMS/competition/works_detail?works_id=${id}`,
        method:'get',
    });
}

export function competitionAllow_Api(judge_username,competition_id,round){
    return request({
        url:`/CMS/competition/works_allow?judge_username=${judge_username}&competition_id=${competition_id}&round=${round}`,
        method:'get',
    });
}

export function getCompetitionAllow_Api(data){
    return request({
        url:"CMS/competition/works_allow",
        method:'post',
        data:data
    });
}

export function updateCompetitionAllow_Api(data){
    return request({
        url:"CMS/competition/works_allow",
        method:'put',
        data:data
    });
}

export function deleteCompetitionAllow_Api(data){
    return request({
        url:"CMS/competition/works_allow",
        method:'delete',
        data:data
    });
}

export function competitionJudgeOutput_Api(data){
    return request({
        url:"CMS/competition/judge_output",
        method:'post',
        data:data,
        responseType: 'arraybuffer'
    });
}

export function competitionTrack_Api(id){
    return request({
        url:`CMS/competition/competition_track?competition_id=${id}`,
        method:'get',
    });
}

export function createCompetitionTrack_Api(data){
    return request({
        url:"CMS/competition/competition_track",
        method:'post',
        data:data
    });
}

export function updateCompetitionTrack_Api(data){
    return request({
        url:"CMS/competition/competition_track",
        method:'put',
        data:data
    });
}

export function deleteCompetitionTrack_Api(data){
    return request({
        url:"CMS/competition/competition_track",
        method:'delete',
        data:data
    });
}

export function outputCompetitionWorks_Api(data){
    return request({
        url:"CMS/competition/works_output",
        method:'post',
        data:data,
        responseType: 'arraybuffer'
    });
}

export function contestantsDetail_Api(data){
    return request({
        url:"CMS/competition/contestants_detail",
        method:'post',
        data:data
    });
}

export function updateContestantsDetail_Api(data){
    return request({
        url:"CMS/competition/contestants_detail",
        method:'put',
        data:data
    });
}

export function deleteContestantsDetail_Api(data){
    return request({
        url:"CMS/competition/contestants_detail",
        method:'delete',
        data:data
    });
}


// WEBPACK FOOTER //
// ./src/apis/competition.api.js